// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Loading */
    --ds-icon-button-loading-icon-color: var(--ds-color-grey-10);
    --ds-icon-button-loading-bg-color: var(--ds-color-grey-50);
    /* Input Like */
    --ds-input-like-button-color: var(--ds-color-grey-20);
    --ds-input-like-button-hover-color: var(--ds-color-grey-10);
    --ds-input-like-button-disabled-color: var(--ds-color-grey-30);
    --ds-input-like-button-loading-icon-color: var(--ds-color-grey-10);
    /* ---------- BACKGROUNDS ---------- */
    /* Ghost */
    --ds-icon-button-ghost-hover-bg-color: var(--ds-color-grey-indigo-70);
    /* Input-like */
    --ds-input-like-button-bg-color: var(--ds-color-grey-indigo-70);
    --ds-input-like-button-hover-bg-color: var(--ds-color-grey-indigo-70);
    --ds-input-like-button-disabled-bg-color: var(--ds-color-grey-50);
    --ds-input-like-button-loading-bg-color: var(--ds-color-grey-50);
    /* ---------- BORDERS ---------- */
    /* Input Like */
    --ds-input-like-button-border-color: var(--ds-color-grey-indigo-40);
    --ds-input-like-button-hover-border-color: var(--ds-color-grey-20);
    /* Box Shadows */
    /* Input Like */
    --ds-input-like-button-box-shadow: 0 0 0 1px
        var(--ds-input-like-button-border-color) inset;
    --ds-input-like-button-hover-box-shadow: 0 0 0 1px
        var(--ds-input-like-button-hover-border-color) inset;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
